<template>
  <div>
    <div v-if="!innerIsReview">
      <validation-provider
              v-slot="{ errors }"
              :name="label || 'This'"
              :rules="rules"
              mode="eager"
              v-bind="providerProps"
              v-show="innerShouldShow"
              :vid="'validate-'+fieldAssignmentId"
      >
        <span class="field-directions" v-if="directions" v-html="directions"></span>
        <GmapMap
                ref="mapRef"
                :center="position"
                class="google-map"
                :zoom="zoom"
                @zoom_changed="updateZoom($event)"
        >
          <template>
            <GmapMarker
                    :key="'venueLocation'"
                    :position="position"
                    :draggable="true"
                    @dragend="dragEnd($event)"
            ></GmapMarker>
          </template>
        </GmapMap>
      </validation-provider>
    </div>
    <div v-else>
      <type-review
              v-if="extraProps"
              :label="label"
              :directions="directions"
              :should-show="innerShouldShow"
              :show-edit-button="extraProps.editButton"
              :page-number="extraProps.originalPageNumber"
              @goToPage="goToPage($event)"
      >
        <div v-if="innerValue">

        </div>
        <div v-else>N/A</div>
      </type-review>
    </div>
  </div>
</template>

<script>
  import { gmapApi } from 'vue2-google-maps';
  import formMixin from '../formMixin'
  import TypeReview from "./TypeReview";

  export default {
    name: 'TypeGooglePlace',
    mixins: [formMixin],
    components:{
      TypeReview
    },
    props: {
      showIcon: {
        type: Boolean,
        default: true,
      },
    },
    data: () => {
      return {
        map: null,
        zoom:18,
        maxZoom:20,
      }
    },
    methods: {
      updateZoom(zoomedTo) {
        this.zoom = zoomedTo > this.maxZoom ? this.maxZoom : zoomedTo;
      },
      dragEnd(ev) {
        const paths = this.field_path.split('.');
        if( paths[0] ) {
          this.setSiblingValue(paths[0]+'.latitude', ev.latLng.lat());
          this.setSiblingValue(paths[0]+'.longitude', ev.latLng.lng());
        }
      }
    },
    computed: {
      defaults() {
        return {
          label: this.innerLabel,
          directions: this.directions,
          persistentHint: true,
        }
      },
      rules() {
        return {
          ...this.validation_settings,
          required:!!this.validation_settings.required && !!this.innerShouldShow,
        }
      },
      google: gmapApi,
      position() {
        let coords = (this.innerValue || '').split(',');
        return {
          lat: parseFloat(coords[0]) || 0,
          lng: parseFloat(coords[1]) || 0
        }

      }
    },
    mounted() {
      this.fieldLoaded(); // signal to the form we are loaded
    }
  }
</script>
<style lang="scss">
    .google-map {
        width:100%;
        height: 50vw;
    }

    @media (max-device-width: 1200px) {
      .google-map {
        height:66vw;
      }
    }

    @media (max-device-width: 667px) {
      .google-map {
        height:calc(100vw - 64px);
      }
    }
</style>
